import { useContext } from "react";
import { Link } from "@mui/material";
import { HashContext } from "context/hash-context";
import styles from "./styles";

function Subtopic({ props }) {
  const { topic, anchorTag, pageRef, menuRef } = props;
  const routeId = useContext(HashContext);
  const isActive = routeId === anchorTag;

  return (
    <Link
      key={anchorTag}
      ref={menuRef}
      sx={{
        ...styles,
        ...(isActive
          ? {
              fontWeight: "bold",
              color: "primary.secondary",
              borderLeft: (theme) =>
                `4px solid ${theme.palette.primary.secondary}`,
              paddingLeft: "16px",
            }
          : {}),
      }}
      onClick={() => {
        const menuElement = document.getElementById(`${anchorTag}-menu`);
        if (menuElement) {
          menuElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        pageRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }}
      id={`${anchorTag}-menu`}
      href={anchorTag}
    >
      {topic}
    </Link>
  );
}

export default Subtopic;
